import React from "react";
import { Link } from "react-router-dom";

const Footer = ({ presentationMode }) => {
  if (presentationMode) return null;

  return (
    <footer className="footer">
      <div className="footer-content">
        <span className="footer-copyright">
          <b>© STREEN Studio 2026</b>
        </span>

        <nav
          className="footer-nav"
          aria-label="Rechtliche Informationen"
        >
          <Link to="/impressum">Impressum</Link>
          <Link to="/datenschutz">Datenschutz</Link>
          <Link to="/barrierefreiheit"> Barrierefreiheit </Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;